import { useState } from "react";

import { Button } from "@/components";
import { ArrowLeft } from "@/components/Icons";
import { Input } from "@/components/Input";
import styles from "@/styles/containers/configure.module.scss";

export function ConfigurationFieldInput({ label, type = 'tel', maxLength,  value, onConfirm, onCancel, onValidate }) {
  const [inputValue, setInputValue] = useState(value);

  return (
    <div className={styles.fieldContainer}>
      <p className={styles.title}>{label}</p>

      <div className={styles.enterCode}>
        
        <Input
          autoFocus
          design="great"
          type={type}
          value={inputValue}
          maxLength={maxLength}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </div>

      <div className={styles.footer}>
        <div className="d-flex align-center justify-between w-100">
          <Button
            design="secondary"
            onClick={onCancel}
          >
            <ArrowLeft />
            Voltar
          </Button>
          <Button
            disabled={onValidate && !onValidate(inputValue)}
            onClick={() => {
              onConfirm(inputValue);
            }}
          >
            Avançar
          </Button>
        </div>
      </div>
    </div>
  );
}
